// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBaby = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.236 16a2 2 0 01-1.49-.667l-1.491 1.334A4 4 0 0012.236 18a4 4 0 002.981-1.333l-1.49-1.334c-.367.41-.899.667-1.49.667M17 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0M8.5 14a1.5 1.5 0 100-3 1.5 1.5 0 000 3" />,
    <path
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m2 0a8 8 0 018-8 2 2 0 110 4c-.357 0-.641-.11-.814-.24-.173-.128-.186-.23-.186-.26H9c0 .8.434 1.447.986 1.86.55.414 1.266.64 2.014.64a4 4 0 003.874-5.001A8 8 0 114 12"
    />
  );
export default SvgIconBaby;
